module.exports = __webpack_public_path__ + "img/E31.e49e89d0.png";